<div style="margin: 16px; padding-bottom: 1px">
    <div style="margin: auto" [style.width]="authService.isLoggedIn() ? '100%' : '80%'">
        <div style="
        padding: 16px;
        width: 100%;
        background: #fff;
        font-size: 14px;
        font-weight: 500;
        border-radius: 8px;
      " class="card-item app-shadow">
            <div *ngIf="!vendor || !isValidProvider">
                <nz-alert nzType="warning" nzMessage="Warning" nzDescription="{{ getMessage() }}" nzShowIcon></nz-alert>
            </div>
            <div *ngIf="vendor && isValidProvider">
                <div class="text-center font-18 font-weight-700" style="margin-bottom: 15px">
                    {{ vendor }} Api Doc
                </div>
                <div>
                    <div class="font-weight-600 font-16">Get product list api</div>
                    <span class="font-weight-600"> Method: </span>
                    <span style="font-style: italic">GET</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="productsApi"></app-copy-to-clipboard>
                </div>
                <div class="font-italic">Success Response:</div>
                <div class="code-block-container">
                    <pre class="code-block">
              <code>
                  <span>
                      {{successRes}}
                  </span>
              </code>
          </pre>
                </div>
                <div class="font-italic">Server error response:</div>
                <div class="code-block-container">
                    <pre class="code-block">
              <code>
                  <span>
                      {{wrongServiceRes}}
                  </span>
              </code>
          </pre>
                </div>
                <div>
                    <div class="font-weight-600 font-16">
                        OTP Send api(Initiate charging)
                    </div>
                    <span class="font-weight-600"> Method: </span>
                    <span style="font-style: italic">POST</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="createCheckoutSessionApi"></app-copy-to-clipboard>
                </div>
                <div class="font-italic">Reqeust body:</div>
                <div class="code-block-container">
                    <pre class="code-block">
              <code>
                  <span>
                      {{reqBody}}
                  </span>
              </code>
          </pre>
                </div>
                <div class="font-italic">Success Response:</div>
                <div class="code-block-container">
                    <pre class="code-block">
              <code>
                  <span>
                      {{reqSucRes}}
                  </span>
              </code>
          </pre>
                </div>
                <div class="font-italic">Server error response:</div>
                <div class="code-block-container">
                    <pre class="code-block">
              <code>
                  <span>
                      {{reqServerErrorRes}}
                  </span>
              </code>
              
          </pre>
                    <div class="font-italic">Multiple OTP response:</div>
                    <div class="code-block-container">
                        <pre class="code-block">
                            <code>
                                <span>
                                    {{optDuplicateRes}}
                                </span>
                            </code>
                        </pre>
                    </div>

                    <div class="font-italic">Blacklist response:</div>
                    <div class="code-block-container">
                        <pre class="code-block">
                            <code>
                                <span>
                                    {{blacklistRes}}
                                </span>
                            </code>
                        </pre>
                    </div>
                </div>
                <div>
                    <div class="font-weight-600 font-16">OTP verify api(charging)</div>
                    <span class="font-weight-600"> Method: </span>
                    <span style="font-style: italic">POST</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="verifyCheckoutSessionApi"></app-copy-to-clipboard>
                </div>

                <div class="font-italic">Reqeust body:</div>
                <div class="code-block-container">
                    <pre class="code-block">
            <code>
                <span>
                    {{otpVerifyReqBody}}
                </span>
            </code>
        </pre>
                </div>
                <div class="font-italic">Success Response:</div>
                <div class="code-block-container">
                    <pre class="code-block">
              <code>
                  <span>
                      {{optVerifySucRes}}
                  </span>
              </code>
          </pre>
                </div>
                <div class="font-italic">Insufficent balance response:</div>
                <div class="code-block-container">
                    <pre class="code-block">
                              <code>
                                  <span>
                                      {{optInsufficentBalRes}}
                                  </span>
                              </code>
                          </pre>
                </div>

                <div class="font-italic">Server error response:</div>
                <div class="code-block-container">
                    <pre class="code-block">
            <code>
                <span>
                    {{optVerifyServerError}}
                </span>
            </code>
        </pre>
                </div>

                <div>
                    <div class="font-weight-600 font-16">Subscription check api</div>
                    <span class="font-weight-600"> Method: </span>
                    <span style="font-style: italic">GET</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="checkSubscriptionApi"></app-copy-to-clipboard>
                </div>
                <div class="code-block-container">
                    <div class="font-italic">Success Response:</div>
                    <pre class="code-block">
            <code>
                <span>
                    {{checkReqRes}}
                </span>
            </code>
        </pre>
                </div>
                <div class="code-block-container">
                    <div class="font-italic">Not found subscription Response:</div>
                    <pre class="code-block">
              <code>
                  <span>
                      {{checkNotFoundRes}}
                  </span>
              </code>
          </pre>
                </div>
                <div>
                    <div class="font-weight-600 font-16">Subscription cancel api</div>
                    <span class="font-weight-600"> Method: </span>
                    <span style="font-style: italic">POST</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="cancelSubscriptionApi"></app-copy-to-clipboard>
                    <div>
                        <span class="font-weight-600">
                            Api key(need to pass in header):
                        </span>
                        <span style="font-style: italic">x-api-key</span>
                    </div>
                    <div>
                        <span class="font-weight-600"> Value: </span>
                        <span style="font-style: italic">check it in
                            <span class="app-link">cancelApiEncryptionDoc</span>
                        </span>
                    </div>
                </div>
                <div>
                    <div class="font-italic">Reqeust body:</div>
                    <div class="code-block-container">
                        <pre class="code-block">
                  <code>
                      <span>
  "8m9XxNZx0MdaJmTvOyzKD8WWZmvd6t0/cquRBUIOdGXRIv0lbJKOC3AFeRZ/w+0ZZ6TCcFxAd4hFOKVaG/ri3w=="
                      </span>
                  </code>
              </pre>
                    </div>
                    <div class="font-16">Note:</div>
                    Here Request body is a encrypted string. See more about encryption in
                    <span class="app-link">cancelApiEncryptionDoc</span>
                    <p>
                        To ensure fair access and prevent abuse, this API endpoint enforces a rate limit. Users are
                        limited to <b>3 requests per
                            24-hour period</b>. If a user exceeds this limit from a single IP address, their requests
                        will be blocked for the remaining
                        duration of the 24-hour window.
                    </p>

                </div>
                <div class="font-italic">Success Response:</div>
                <div class="code-block-container">
                    <pre class="code-block">
                     <code>
                         <span>
                             {{cancelReq}}
                         </span>
                     </code>
                </pre>
                </div>
                <div class="font-italic">Failed Response:</div>
                <div class="code-block-container">
                    <pre class="code-block">
                    <code>
                      <span>
                          {{cancelRes}}
                      </span>
                    </code>
                </pre>
                </div>

                <div class="font-italic">IP clock Response:</div>
                <div class="code-block-container">
                    <pre class="code-block">
                       <code>
                         <span>
                             {{ipBlockRes}}
                         </span>
                       </code>
                     </pre>
                </div>

                <!-- How to configure Notification : Start-->
                <div>
                    <h1>Setup Notification</h1>
                    <p>
                        Set up the notification mechanism within the provider's system to
                        send notifications to provider after completing a payment
                        transaction. This involves configuring the HTTPS API endpoint to
                        receive notifications and defining the parameters required for
                        notification delivery.
                    </p>

                    <h2>Notification Parameters</h2>
                    After completing a payment transaction,sending notifications through
                    the HTTPS API:

                    <ul>
                        <li>
                            Notification URL: The URL where the HTTPS API endpoint is hosted
                            by the provider.
                        </li>
                        <li>
                            MSISDN: The mobile number associated with the user's account,
                            which is charged or undergoing an action (e.g.,
                            activation,deactivation, charge renewal).
                        </li>
                        <li>
                            ServiceID: Unique identifier for the service notifying the user.
                        </li>
                        <li>
                            ActionType: Type of action being notified (e.g. ACT, REN, DACT).
                        </li>
                        <ul>
                            <li>ACT : Activation</li>
                            <li>DACT : Deactivation</li>
                            <li>REN : Renewal</li>
                        </ul>
                        <li>
                            ActionMessage: ActionType description or notification content.
                            (e.g. deactivation, Charged)
                        </li>
                    </ul>

                    <h2>Sample Notification URL</h2>
                    <p>
                        The HTTPS API notification URL format for sending notifications to
                        users is as follows:
                    </p>

                    <div class="code-block-container">
                        <pre class="code-block">
                                                <code>
                                                    <span style="padding: 10px;">{{"https://www.example.com/notification?msisdn={msisdn}&ServiceID={serviceId}&ActionType={action}&ActionMessage={messageId}"}}</span>
                                                </code>
                                            </pre>
                    </div>
                </div>

                <!-- How to configure Notification : End-->
            </div>
        </div>
    </div>
</div>